import { getPortDef } from '@shared/port-v1.0.0'

export const getCustomPropsPortDef = () => {
	return {
		...getPortDef({
			name: 'customProps',
			displayName: 'Custom props',
			group: 'Advanced',
			type: 'objectEval',
			visibleAt: 'both',
			codeComment: '//(props) => { return { } }',
		}),
		index: 1000,
	}
}
